import script from "./docdownData.vue?vue&type=script&setup=true&lang=js"
export * from "./docdownData.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__